import isNode from '../ajio-util/isNode';

let proxyAgent;
if (isNode()) {
  const tunnel = require('tunnel2');
  proxyAgent = tunnel.httpsOverHttp({
    proxy: {
      host: 'http://lwproxy.jio.com',
      port: '8080'
    }
  });
}
module.exports = {
  endpoints: {
    category: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/products/category'
    },
    capsulecp: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/capsule'
    },
    capsulenewin: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/capsule/capsuleNewIn'
    },
    topSearches: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/products'
    },
    products: {
      href: 'http://pdpaggregator.rep-ajio.jio.com/aggregator/pdp'
    },
    checkProductServiceability:{
      href: 'http://pdpaggregator.rep-ajio.jio.com/aggregator/pdp/serviceability'
    },
    curatedPage: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/category'
    },
    recommend: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/recommend'
    },
    recommendation: {
      href: 'https://rep-sf.ajio.jio.com/rilfnlwebservices/recommendation/v1/pairing/products'
    },
    ensamble: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/ensamble'
    },
    recentlyViewed: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/recentlyViewed'
    },
    productdeliverycheck: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/productdeliverycheck'
    },
    capsules: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/capsule/productCapsule'
    },
    search: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/products/search'
    },
    newdesignhomepage: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/newdesignhomepage'
    },
    landingPageRuntime: {
      href: 'http://rep-sf.ajio.jio.com/storefront/cms/page'
    },
    cmsComponent: {
      href: 'http://rep-sf.ajio.jio.com/storefront/cms/component'
    },
    runtimeLocale: {
      href: 'http://rep-sf.ajio.jio.com/storefront/cms/locale'
    },
    runtimeNavigationDesktop: {
      href: 'http://rep-sf.ajio.jio.com/storefront/cms/navigation'
    },
    runtimeNavigationDesktopPreview: {
      href: 'http://rep-cms.services.ajio.jio.com/cms/v1/navigation/preview'
    },
    landingPageRuntimePreview: {
      href: 'http://rep-cms.services.ajio.jio.com/cms/v1/page/preview'
    },
    landingPageRuntimeArchive: {
      href: 'http://rep-cms.services.ajio.jio.com/cms/v1/page/archive'
    },
    newcategoryselection: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/newcategoryselection'
    },
    searchsuggestions: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/products/suggestions'
    },
    navigationdesktop: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/navigation/all'
    },
    navigationmobile: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/navigation/navnodes'
    },
    myaccount: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/navigation'
    },
    footer: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/footer/navlinks'
    },
    minicart: {
      href: 'http://rep-sf.ajio.jio.com/cart/rollover/json/MiniCart'
    },
    wishlist: {
      href: 'http://rep-sf.ajio.jio.com/addToWishlistAjax'
    },
    leaderBoard: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/topshopper'
    },
    accountCheck: {
      href: 'http://rep-identity.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/accountCheck'
    },
    loginToken: {
      href: 'http://rep-identity.services.ajio.jio.com/rilfnlwebservices/oauth/token'
    },
    generateLoginOTP: {
      href: 'http://rep-identity.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/login/sendOTP'
    },
    signUpAndSocial: {
      href: 'http://rep-identity.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    signInSocial: {
      href: 'http://rep-identity.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    selfcareInitChat: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/selfcare/initiateChat'
    },
    selfcarefaq: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/selfcare/footer'
    },
    selfcareFaqSearch: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/searchService/FAQ/search'
    },
    setNewPassword: {
      href:
        'http://rep-identity.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/forgottenpasswordtokens/set/password'
    },
    selfcareOrderDetails: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    getProfile: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/users/current'
    },
    npsFormQuestionsData: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/survey'
    },
    npsFormAnswerSubmit: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/survey/submitsurvey'
    },
    getStoreList: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/SISStore'
    },
    getStoreListCms: {
      href: 'http://rep-sf.ajio.jio.com/storefront/cms/stores'
    },
    getStoreListCmsRevampedPreview: {
      href:
        'https://gcprep-cms.services.ajio.jio.com/cms-editor/store/preview?platform=MOBILE&tenantId=AJIO'
    },
    sizeGuide: {
      href: 'http://rep-sizechart.ajio.jio.com/sizechart/getBrickBrandVendorStyleSizeChart'
    },
    productLevelSizeGuide: {
      href: 'http://rep-sizechart.ajio.jio.com/sizechart/productLevelSizeGuide'
    },
    recommendUserSize: {
      href: 'http://rep-sizechart.ajio.jio.com/sizechart/recommendUserSize'
    },
    fetchUserSizeGuide: {
      href: 'http://rep-sizechart.ajio.jio.com/sizechart/fetchUserSizeGuide'
    },
    kioskIPWhitelist: {
      href: 'https://rep-assets.services.ajio.jio.com/snoop/kioskIPWhitelist.json'
    },
    roadblock: {
      href:
        'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/roadblockbannercmp?uiel=Mobile&format=json'
    },
    appticker: {
      href:
        'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/appstickybannercmp?uiel=Mobile&format=json'
    },
    submitAssistantId: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/submitEmpId'
    },
    verifyOTP: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/login/verifyOTP'
    },
    generateCreditUsageOTP: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/kiosk/sendOTP'
    },
    signUpKiosk: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/registerKiosk'
    },
    kioskEntryPage: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/kiosklandingpage'
    },
    sessionClear: {
      href: 'http://rep-identity.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    checkDeliveryDetails: {
      href: 'http://pdpaggregator.rep-ajio.jio.com/aggregator/edd/checkDeliveryDetails'
    },
    checkServiceableCart: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    mobileBottomNavList: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/cms/component'
    },
    uploadReturnProductImages: {
      href:
        'https://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/users/USER_EMAIL_ID/returns/uploadReturnimage'
    },
    flashSaleApiUrl: {
      href: 'http://flashsale.rep-ajio.jio.com/flashsale'
    },
    flashSaleUrl: {
      href: 'https://flashsale.services.ajio.com/flashsale'
    },
    fetchIfscCodeDetails: {
      href: 'https://payment.rep-ajio.jio.com/payment-engine/api/v1/bank/details'
    },
    luxeBrandsList: {
      href:
        'https://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/catalogs/rilfnlProductCatalog/Online/categories/luxebrands'
    },
    bankOffers: {
      href: 'https://rep-sf.ajio.jio.com/rilfnlwebservices/v2/rilfnl/allActiveBankOffer'
    },
    fetchBankTransferStatus: {
      href: 'https://payment.rep-ajio.jio.com/payment-engine/api/v1/refund/bank-transfer-status'
    },
    affiseGetConversions: {
      href: 'https://api-ajios.affise.com/3.0/stats/conversions'
    },
    affiseEditConversions: {
      href: 'https://api-ajios.affise.com/3.0/admin/conversion/edit'
    },
    affisePostback: {
      href: 'https://offers-ajios.affise.com/postback'
    },
    customerTypeUAAS: {
      href: 'http://uaas-gcp.ajio.com/uaas/v2/rilfnl/users/CUSTOMER_ID/customertype'
    },
    customerTypeUAASV4: {
      href: 'http://uaas-gcp.ajio.com/uaas/v4/rilfnl/users/customertype?service='
    },
    myAccountCMS: {
      href: 'http://rep-sf.ajio.jio.com/storefront/cms/page/static?content=navigation&name=myaccount'
    },
    uaasVerifyPan: {
      href: 'http://uaas-gcp.ajio.com/uaas/users/verifyTaxPayerId'
    },
    accountDelete: {
      href: 'http://rep-sf.ajio.jio.com/uaas/users/CUSTOMER_ID/deleteAccount'
    },
    rushAvailabilityCall: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/v1/deliveryType/availability'
    },
    membershipDetails: {
      href: 'http://api-internal.ajioreplica.jio.com/membership/runtime'
    },
    jioAdsSapiApi: {
      href: 'https://mercuryads.jio.com/delivery/sapi.php'
    },
    productDeliveryTypeRush: {
      href: 'http://pdpaggregator.rep-ajio.jio.com/aggregator/pdp/deliveryType'
    },
    recommendationWidgetOsmos: {
      href: 'http://rep-sf.ajio.jio.com/rilfnlwebservices/recommendation/v1/page/data'
    },
    bannerAdsOsmos: {
      href: 'https://ajio-ba.o-s.io/v2/bsda/pt'
    },
    osmosClickTracker: {
      href: 'https://t.o-s.io/aclick/'
    },
    osmosImpressionTracker: {
      href: 'https://t.o-s.io/events?event_name=funnel_impression'
    },
    recommendationTrendsVibes: {
      href: 'https://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/recommendation/v1/trends'
    },
    crossSellCartRecommendations: {
      href: 'https://gcprep-search.services.ajio.jio.com/searchservices/v1/cross-sell/recommendations'
    },
    galleriGenerateTokenAPIURL: {
      href: 'http://uaas-gcp.ajio.com/uaas/v1/creator-commerce/auth-token'
    },
  },
  properties: {
    version: '01.03.00',
    environment: 'PRODUCTION_REPLICA',
    siteUrl: 'https://www.rep-ajio.jio.com',
    parentUrl: 'https://www.rep-ajio.jio.com',
    baseImgUrl: 'https://rep-assets.services.ajio.jio.com',
    assetUrl: 'https://rep-assets.services.ajio.jio.com',
    imageBaseUrl: 'https://rep-assets.services.ajio.jio.com',
    apiUrl: 'http://rep-sf.ajio.jio.com',
    gamificationApiUrl: 'http://rep-gamification.services.ajio.jio.com/gamification',
    paymentURL: 'https://payment.rep-ajio.jio.com',
    cartUrl: 'http://gcprep-cart-engine.services.ajio.jio.com',
    wishlistUrl: 'http://gcprep-wishlist-internal.services.ajio.jio.com',
    luxeURL: 'https://luxe.rep-ajio.jio.com',
    streetURL: 'https://street.ajio.com',
    loginPageURL: 'https://rep-login.web.services.ajio.jio.com',
    pAPI: 'https://payment.rep-ajio.jio.com',
    npeBaseUrl: 'http://rep-runtime.promoengine.services.ajio.jio.com',
    cemUrl: 'https://www.ajio.com/cem',
    previewCheck: false,
    gtmCode: '5XMX63',
    optimizeID: 'OPT-KTLN3ZV',
    GAID: 'UA-68002030-1',
    APIErrorGAID: 'UA-68002030-8',
    appAjioText: 'AJIO Online Shopping App',
    appAjioInstallText: 'Use App for a better experience',
    androidAppBaseLink: 'android-app://com.ril.ajio/',
    iosAppBaseLink: 'ios-app://1113425372/',
    fbAppId: '530272470511330',
    googleClientId: '451315316170-qir4dv350qkc1214i1786p0tq184df0m.apps.googleusercontent.com',
    roadBlock: true,
    dataGrinchAppKey: 'app5b30be1f0e5bf814621703f9',
    rumMOKey: 'c58a39eb46bfd43b62704a0ecf8d6fd8',
    pe: 'ON', // "OFF" for turning OFF
    timeout: 25000,
    timeoutNode: 30000,
    timeoutClient: 40000,
    dropAtStore: 'ON',
    gpayAppticker: 'ON', // ON = hide, OFF = show
    gpayRoadBlock: 'ON', // ON = hide, OFF = show
    dropAtStoreBanner: 'Available only at Trends stores in Bangalore',
    pickFromStore: 'OFF',
    pickFromStoreBanner: 'Available only at Trends stores in Bangalore',
    downloadInvoiceFlag: true,
    cleverTapID: '48K-4R4-K84Z',
    firebaseConfig: JSON.stringify({
    
    }),
    firebaseConfig_M: JSON.stringify({
  
    }),
    webAppVersion: '1.0.0',
    segment_api_write_key : 'hKdcCBW9TrvuhEehZTBSSaJLGNhLRasy',
    copilotURL: 'https://script.copilot.live/v1/copilot.min.js?tkn=cat-6cvtdddi',
    amplitude_experiment_server_key: 'server-AblRWcufkysyE4w4XxpxB7N8XuL517jZ',
    ajioLoyaltyServiceUrl: 'https://payment.rep-ajio.jio.com',
    botifyWebsiteId: 'UO4YE7',
    amplitude_api_key: '9ac8bf1364978b2734f25fe8793278c8'
  }
};